// import React from 'react'
import { useEffect, useState } from 'react'
import useSWR from 'swr'

export default function useUsers() {
  const { data, error, isValidating } = useSWR('user-mgmt/users')
  const [users, setUsers] = useState(
    {
      data: { data: [] },
      isLoading: false,
      isError: error,
      firstPage: '',
      nextPage: '',
      prevPage: '',
      lastPage: '',
      total: ''
    }
  )
  useEffect(() => {
    if (data) setUsers(data)
    return () => {
      if (data) setUsers(data)
    }
  }, [data])

  console.log(users)

  return {
    users: users?.data?.data,
    isLoading: isValidating,
    isError: error,
    firstPage: users?.data.first_page_url,
    nextPage: users?.data.next_page_url,
    prevPage: users?.data.prev_page_url,
    lastPage: users?.data.last_page_url,
    total: users?.data.total
  }
}